'use strict';

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _each2 = _interopRequireDefault(require("lodash/each"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (collection, key) {
  var multi = false;
  var output = {};
  (0, _each2.default)(collection, function (element) {
    var i = element[key];

    if (i !== undefined) {
      if (output[i]) {
        if (!(0, _isArray2.default)(output[i])) {
          output[i] = [output[i]];
        }

        multi = true;
        output[i].push(element);
      } else {
        output[i] = element;
      }
    }
  });

  if (multi) {
    (0, _each2.default)(output, function (value, i) {
      if (!(0, _isArray2.default)(value)) {
        output[i] = [output[i]];
      }
    });
  }

  return output;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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